import useSWR from "swr";
import { packsClient } from "../clients";

const fetcher = async (_key, id: string): Promise<any> => {
  try {
    const { data } = await packsClient.getTeam(id);
    return data;
  } catch (err) {
    throw err;
  }
}

export const useTeamById = (id: string) => {
  const { data, error, isValidating, mutate } = useSWR(id ? [`v1/packs/team`, id] : null, fetcher);

  return {
    data,
    error,
    isLoading: !data && !error,
    isValidating,
    mutate,
  }
}
